export default {
  getContractSection: (state) => state.contractSection,
};
